import { c as _c } from "react/compiler-runtime";
import { Toaster as RHToaster } from 'react-hot-toast';

// `success`/`error` cover toasts raised directly via `toast.success()` /
// `toast.error()` (e.g. dev-utils). `custom` covers toasts raised through
// this app's `Toast.utils.tsx` wrapper (`t.custom`), which needs its own
// entry since react-hot-toast keys durations by its own internal type.
const TOAST_OPTIONS = {
  custom: {
    duration: 3000
  },
  success: {
    duration: 3000
  },
  error: {
    duration: 5000
  }
};
const Toaster = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <RHToaster position="top-right" toastOptions={TOAST_OPTIONS} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default Toaster;